// @ts-check

/**
 *
 * @param {Object} options
 * @param {boolean} options.isRebuyProductDiscovery
 * @returns {Array<{key: string, value: string}>}
 */
export default function formatLineItemAttributes({ isRebuyProductDiscovery }) {
  let attributes = []

  if (isRebuyProductDiscovery) {
    attributes = [
      ...attributes,
      { key: '_attribution', value: 'Product Discovery' },
      { key: '_source', value: 'Rebuy' },
      { key: '_widget_id', value: 'recess_custom_cart_widget' }
    ]
  }

  return attributes
}
